<template>
  <section class="fast-dialog-container">
    <el-dialog
      title="快速采集"
      width="750px"
      v-loading="loading"
      :visible.sync="dialogVisible"
      :modal-append-to-body="false"
    >
      <header>
        <div class="img">
          <el-image :src="$getPath(url)" fit="fill">
            <div slot="error" class="image-slot">
              <i class="el-icon-picture-outline"></i>
            </div>
          </el-image>
        </div>
        <div class="title-wrap">
          <div class="title">{{modelName}}</div>
          <div class="rule">{{rules}}</div>
        </div>
      </header>
      <dialog-form
        ref="form"
        class="resource-upload-container"
        :showSubmitButton="false"
        :form="form"
        :formItems="formItems"
        :rules="formRules"
        :labelWidth="labelWidth"
        :options="{
          fieldIdsOptions,
          columnOptions,
          contentModelOptions
        }"
      >
        <template #spaceId="scope">
          <div class="resource-item">
            <resource-tree v-bind="tree" v-model="scope.form.resource"/>
          </div>
        </template>
      </dialog-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="handleCancel">取消</el-button>
        <el-button size="small" type="primary" @click="handleConfirm">仅保存任务</el-button>
        <el-button size="small" type="primary" @click="handleCollect">开始采集</el-button>
      </span>
    </el-dialog>
    <fast-collect-dialog
      :modelType="modelType"
      :keyword="form.keyword"
      ref='fastCollect'/>
  </section>
</template>
<script>
import dialogForm from '@/components/mixins/dialogForm'
import FastCollectDialog from './FastCollectDialog'
import { loopOptions } from '@/utils'
import {
  mapGetters,
  mapActions
} from 'vuex'

export default {
  name: 'FastDialog',
  mixins: [dialogForm],
  props: ['url', 'modelName', 'rules', 'modelType', 'Update', 'defaultForm'],
  components: {
    FastCollectDialog
  },
  data () {
    return {
      loading: false,
      dialogVisible: false,
      labelWidth: '154px',
      fieldIdsOptions: [],
      form: {
        id: '',
        name: this.modelName,
        keyword: '',
        fieldIds: [],
        dataPosition: 1,
        channelId: '',
        modelId: '',
        modelType: this.modelType
      }
    }
  },
  computed: {
    ...mapGetters(['columnOptions', 'contentModelOptions']),
    formItems () {
      let items = [
        {
          prop: 'name',
          label: '任务名称',
          maxlength: 50
        },
        {
          prop: 'fieldIds',
          label: '选择采集字段',
          type: 'checkbox',
          options: 'fieldIdsOptions',
          popoverText: '可按照字段的对应规则创建内容模型，规则如下：标题（title）、文章链接（outLink）、时间（releaseTime）、来源（contentSourceId）（contxt）；若所选的内容模型中不包含所选字段，则不保存该字段；'
        },
        {
          prop: 'dataPosition',
          label: '数据存储位置',
          type: 'radio',
          options: [
            {
              label: '采集内容库',
              value: 1
            },
            {
              label: '栏目',
              value: 2
            }
          ]
        },
        {
          prop: 'channelId',
          label: '',
          labelWidth: '154px',
          hiddenKey: 'dataPosition',
          hiddenValue: 2,
          type: 'selectTree',
          options: 'columnOptions'
        },
        {
          prop: 'modelId',
          label: '选择内容模型',
          type: 'select',
          options: 'contentModelOptions',
          popoverText: '若所选的内容模型中不包含所选字段，则不保存该字段'
        }
      ]
      if (this.modelType === 2) {
        items.splice(1, 0, {
          prop: 'keyword',
          label: '关键词',
          maxlength: 50
        })
      } else if (this.modelType === 3) {
        items.splice(1, 0, {
          prop: 'keyword',
          label: '用户UID',
          maxlength: 50
        })
      } else if (this.modelType === 4) {
        items.splice(1, 0, {
          prop: 'keyword',
          label: '公众号名称',
          maxlength: 50
        })
      }
      return items
    },
    formRules () {
      return {
        name: [
          {
            validator: (rule, value, callback) => {
              if (value) {
                var params = {
                  name: value,
                  id: this.form.id
                }
                this.$request.fetchCollectTaskUnique(params).then(res => {
                  if (res.code === 200 && res.data) {
                    callback()
                  } else {
                    callback(new Error('任务名称不能重复'))
                  }
                })
              }
            },
            trigger: 'blur'
          }
        ]
      }
    }
  },
  methods: {
    ...mapActions('column', ['FetchColumnOptions']),
    ...mapActions('content', ['FetchContentModeList']),
    showDialog () {
      this.fetchFiledIdsOption()
      if (!this.Update && !this.form.name) {
        this.form.name = this.modelName
      }
      if (this.Update && this.defaultForm) {
        Object.keys(this.defaultForm).forEach(k => {
          if (k in this.form) {
            this.form[k] = this.defaultForm[k]
          }
        })
      }
      this.dialogVisible = true
    },
    handleCancel () {
      this.loading = false
      this.dialogVisible = false
    },
    // 保存任务
    handleConfirm () {
      this.loading = true
      const params = {
        ...this.form,
        status: 2
      }
      const api = this.Update ? 'fetchCollectTaskUpdate' : 'fetchCollectTaskCreate'
      this.$request[api](params).then(res => {
        if (res.code === 200) {
          this._messageSuccess('save')
        }
        this.handleCancel()
      }).catch(this.handleCancel)
    },
    // 开始采集
    handleCollect () {
      this.loading = true
      const params = {
        ...this.form,
        status: 1
      }
      const api = this.Update ? 'fetchCollectTaskUpdate' : 'fetchCollectTaskCreate'
      this.$request[api](params).then(res => {
        if (res.code === 200) {
          this.$refs.fastCollect.showDialog(res.data.id)
        }
        this.handleCancel()
      }).catch(this.handleCancel)
    },
    fetchFiledIdsOption () {
      const params = {
        status: this.modelType
      }
      this.$request.fetchFiledIdsOption(params).then(res => {
        if (res.code === 200) {
          this.fieldIdsOptions = loopOptions(res.data)
        }
      })
    }
  },
  mounted () {
    this.FetchColumnOptions()
    this.FetchContentModeList()
  }
}
</script>
<style lang="scss" scoped>
.fast-dialog-container{
  header{
    display: flex;
    align-items: center;
    padding-bottom: 20px;
    margin-bottom: 20px;
    border-bottom: 1px solid #e8e8e8;
    .img{
      width: 85px;
      height: 85px;
      border-radius: 4px;
      border: 1px solid #e8e8e8;
    }
    .title-wrap{
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: center;
      padding-left: 20px;
      .title{
        color: #333333;
        font-size: 16px;
        line-height: 16px;
        font-weight: bold;
      }
      .rule{
        padding-top: 10px;
        font-size: 14px;
        line-height: 24px;
        color: #666666;
      }
    }
  }
}
</style>
